// extracted by mini-css-extract-plugin
export var addButton = "_bb-0";
export var border = "_bb-8";
export var check = "_bb-h";
export var danger = "_bb-6";
export var dropdownContainer = "_bb-1";
export var editModalBody = "_bb-j";
export var footerContainer = "_bb-i";
export var fullWidth = "_bb-a";
export var hide = "_bb-9";
export var icon = "_bb-3";
export var input = "_bb-7";
export var inputFlex = "_bb-b";
export var inputWrapper = "_bb-c";
export var manualFocus = "_bb-5";
export var optionButton = "_bb-4";
export var pillWrapper = "_bb-e";
export var pointer = "_bb-2";
export var showOverflow = "_bb-f";
export var tagsFlex = "_bb-d";
export var xButton = "_bb-g";